import { render, staticRenderFns } from "./RegionVisitsRateCard.vue?vue&type=template&id=1c8b2600"
import script from "./RegionVisitsRateCard.vue?vue&type=script&lang=js"
export * from "./RegionVisitsRateCard.vue?vue&type=script&lang=js"
import style0 from "./RegionVisitsRateCard.vue?vue&type=style&index=0&id=1c8b2600&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports